var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneColModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.424 9.0015C1.733 9.0015 1.1565 8.77 0.6945 8.307C0.2325 7.844 0.001 7.2675 0 6.5775V2.4225C0 1.7325 0.2315 1.1565 0.6945 0.6945C1.1565 0.2315 1.733 0 2.424 0H21.5775C22.2675 0 22.844 0.2315 23.307 0.6945C23.769 1.1565 24 1.7325 24 2.4225V6.5775C24 7.2675 23.769 7.844 23.307 8.307C22.845 8.77 22.2685 9.0015 21.5775 9.0015H2.424ZM2.424 22.155C1.733 22.155 1.1565 21.9235 0.6945 21.4605C0.2315 20.9985 0 20.422 0 19.731V15.5775C0 14.8875 0.2315 14.311 0.6945 13.848C1.1575 13.385 1.734 13.154 2.424 13.155H21.5775C22.2675 13.155 22.844 13.386 23.307 13.848C23.77 14.31 24.001 14.8865 24 15.5775V19.7325C24 20.4225 23.769 20.9985 23.307 21.4605C22.844 21.9235 22.2675 22.155 21.5775 22.155H2.424Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneColModeIcon);
export default __webpack_public_path__ + "static/media/one-col-mode-icon.1106de6ccb18abcfe8b70eac24d66f9a.svg";
export { ForwardRef as ReactComponent };